import { Typography, Modal, useTheme } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { formatLocalDate } from '../../../../utils/dateUtils';
import { DetailViewContainer, NoteSection } from './NotesRow.styles';

const NotesDetailView = ({ open, onClose, managerNote, employeeNote, date }) => {
    const theme = useTheme();

    return (
        <Modal open={open} onClose={onClose}>
            <DetailViewContainer>
                <Typography variant="h6" mb={2}>
                    Notes for {formatLocalDate(date)}
                </Typography>

                <NoteSection>
                    <Typography variant="subtitle1" color={alpha(theme.palette.text.secondary, 0.6)} mb={1}>
                        Manager Note
                    </Typography>
                    <Typography>{managerNote || 'No manager note'}</Typography>
                </NoteSection>

                <NoteSection>
                    <Typography variant="subtitle1" color={alpha(theme.palette.text.secondary, 0.6)} mb={1}>
                        Employee Note
                    </Typography>
                    <Typography>{employeeNote || 'No employee note'}</Typography>
                </NoteSection>
            </DetailViewContainer>
        </Modal>
    );
};

export default NotesDetailView;
